import { createFileRoute } from "@tanstack/react-router";
import AiiaPage from "@/pages/security/AiiaPage";

export const Route = createFileRoute("/security/aiia")({
  component: AiiaPage,
});
